const { pickBy, findKey, sortBy, isEmpty, } = require('lodash');

const { entries } = Object;

const fields = () => {
  return {
    name: {
      type: 'string',
      label: '名称',
      validations: {
        required: v => !isEmpty(v),
      },
    },
  };
};

exports.fields = fields;
